import {
  ConfigStoreStatus,
  useConfigSelection,
  useUnknownConfigProperty,
} from "@leagueplatform/config";

// Server-driven flag from `GET {api}/v{n}/sdk-configs`. Same key and same
// transport Android reads it from (`EmblemhealthFeatureFlags.enableCareFinder`),
// so one Config-service rollout covers both platforms.
export const CARE_FINDER_FLAG_ID = "rel_mps_enableCareFinder";

export const useCareFinderEnabled = () => {
  const enabled = useUnknownConfigProperty(CARE_FINDER_FLAG_ID, false);
  const status = useConfigSelection(
    (configWithStatus) => configWithStatus.status
  );

  // Loading only while the first server-config fetch is outstanding. A fetch
  // that fails with no cache resolves to `false` rather than leaving callers
  // on a spinner forever.
  const isLoading =
    status === ConfigStoreStatus.ClientOnly ||
    status === ConfigStoreStatus.Loading;

  return { enabled, isLoading };
};
